module.exports = __webpack_public_path__ + "img/insurance-logo-1.d3b94ee9.png";